import clsx from 'clsx';
import { useCallback } from 'react';
import { useDebounce } from 'react-use';

import EditableFieldRawHtml from '~components/generic/editable-field/components/EditableFieldRawHtml';
import { IEntityComponentProps } from '~interfaces/props';
import { useSetUiComponentCss } from '~modules/ui-component-css/UiComponentCssContext';

export default function ModuleUiComponentCss(props: IEntityComponentProps) {
  const setContext = useSetUiComponentCss();

  const updateContext = useCallback(() => {
    const data = props.data;
    let cssString = '';
    if (data?.attributes?.field_css_source_code && typeof data.attributes.field_css_source_code === 'string') {
      cssString = data.attributes.field_css_source_code;
    }

    let cssFile: string = null;
    if (data?.attributes?.field_file?.fileURL) {
      cssFile = data.attributes.field_file.fileURL;
    }

    setContext({ cssString, cssFile });
  }, [props.data, setContext]);

  useDebounce(
    () => {
      updateContext();
    },
    500,
    [props.data?.attributes?.field_css_source_code, props.data?.attributes?.field_file?.fileURL],
  );

  const { data, canEdit, canMove, editing, className, onChange, origData } = props;

  // Hide this component completely for the "normal viewing" user
  if (!canEdit && !canMove) {
    return null;
  }

  const content = data.attributes;
  const moduleClasses = clsx({
    ...className.module,
    'u-padding-vertical-xl': true,
    relative: true,
    htmlcontent: typeof content.field_no_styles === 'undefined' || content.field_no_styles !== 1,
    'htmlcontent-nostyles': typeof content.field_no_styles !== 'undefined' && content.field_no_styles === 1,
    'c-ui-component': true,
  });
  const containerClasses = clsx({
    ...className.container,
    'px-0': true,
    relative: true,
  });

  return (
    <div className={moduleClasses} id={origData}>
      <div className={containerClasses}>
        <div className="row c-module__header">
          <div className="col col-12">
            <h3>
              <p>UI Component CSS</p>
            </h3>
          </div>
        </div>
        <div className="row flex-wrap c-module__content">
          <div className="col col-12 o-field-text">
            <p>Define CSS code for embedded UI Components in the code area below.</p>
            <p>
              However, if you have a <em>lot</em> of CSS, then it is recommended to upload a CSS file using the upload
              field in the sidebar on the left.
            </p>
          </div>
          <div className="col col-12">
            <div className="u-margin-top-md">
              <EditableFieldRawHtml
                entityType={data.type}
                fieldName="attributes.field_css_source_code"
                data={content.field_css_source_code}
                editing={editing}
                onChange={onChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
